import { datadogRum } from '@datadog/browser-rum';

import { RfqPosition } from 'Services/Query/Auto-RFQ/Types';

// Alternate Items (QOT-1580) frontend telemetry → Datadog RUM. Server-side
// metrics live in App Insights (a separate ticket). These feed the PRD §12
// adoption/engagement metrics (modal open rate, acceptance vs override,
// reorder usage). Fired at the interaction sites; safe no-op if RUM isn't
// initialized.
export type AlternatesReplaceSource =
  | 'in-list'
  | 'catalog'
  | 'ask-ai'
  | 'manual';

const track = (name: string, context: Record<string, unknown> = {}) => {
  try {
    datadogRum.addAction(name, context);
  } catch {
    // RUM not initialized (e.g. tests) — telemetry is best-effort.
  }
};

export const alternatesAnalytics = {
  checkbox: (enabled: boolean) => track('rfq_alternates_checkbox', { enabled }),
  chipOpen: (itemId?: string) => track('rfq_alternates_chip_open', { itemId }),
  modalOpen: (position: RfqPosition, filter: string) =>
    track('rfq_alternates_modal_open', { position, filter }),
  replace: (position: RfqPosition, source: AlternatesReplaceSource) =>
    track('rfq_alternates_replace', { position, source }),
  remove: (position: RfqPosition) =>
    track('rfq_alternates_remove', { position }),
  restore: (position: RfqPosition) =>
    track('rfq_alternates_restore', { position }),
  reset: (position: RfqPosition) => track('rfq_alternates_reset', { position }),
  reorder: (from: RfqPosition, to: RfqPosition) =>
    track('rfq_alternates_reorder', { from, to })
};
